export const EDITING_HEADER = "header.editando_cabecalho";
export const EDIT_HEADER_COMPLETE = "header.edita_cabecalho";
export const EDITED_HEADER_ERROR = "header.editou_cabecalho";

export const FETCHING_PHOTO = "header.buscando_foto";
export const FETCHING_PHOTO_COMPLETE = "header.buscou_foto";
export const FETCHING_PHOTO_ERROR = "header.buscou_foto_Error";
